export default "__VITE_ASSET__DuFqn_MO__"